import AppError from '../errors/AppError';
import { IPaginationReturn } from '../interfaces/IPaginationReturn';
import { IPaymentForm } from '../interfaces/IPaymentForm';

import { useRequest } from './useRequest';

const usePaymentFormService = () => {
  const request = useRequest<IPaymentForm>();
  const path = 'payment-forms';

  const listDynamically = async (queryParams: string): Promise<IPaginationReturn<IPaymentForm[]>> => {
    return await request
      .getManyPaginated({ path: `${path}/dynamically?${queryParams}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  return { listDynamically };
};

export { usePaymentFormService };
